import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const dominios = {
    state: {
        dominios: {
            tiposdocumento: {
                0: 'DNI',
                1: 'Pasaporte',
                2: 'NIE'
            },
            sexo: {
                0: "Masculino",
                1: "Femenino"
            },
            nivel: {
                0: "GRADO (Titulación Educación Superior Plan Bolonia - 4 años)",
                1: "DIPLOMATURA (Titulación Educación Superior Corta - 3 años)",
                2: "POSTGRADO (Maestría o Máster)",
                3: "LICENCIATURA (Titulación Educación Superior Plan anterior a Bolonia - 5 años)",
                4: "DOCTORADO (Tercer Ciclo de Educación Superior - Doctores)"
            },
            situacionlaboral: {
                0: "Parado",
                1: "Activo"
            },
            contactar: {
                0 : 'Preguntarme primero',
                1 : 'Email',
                2 : 'Teléfono',
                3 : 'Linkedin',
            },
            relacionufv: {
                0: 'He realizado un intercambio semestral-anual allí',
                1: 'Soy estudiante de grado completo y he participado en actividades internacionales UFV',
            },
            paises: [
                "Afganistán", "Albania", "Alemania", "Andorra", "Angola", "Antigua y Barbuda", "Arabia Saudita", "Argelia", "Argentina", "Armenia", "Australia", "Austria", "Azerbaiyán", "Bahamas", "Bangladés", "Barbados", "Baréin", "Bélgica", "Belice", "Benín", "Bielorrusia", "Birmania", "Bolivia", "Bosnia y Herzegovina", "Botsuana", "Brasil", "Brunéi", "Bulgaria", "Burkina Faso", "Burundi", "Bután", "Cabo Verde", "Camboya", "Camerún", "Canadá", "Catar", "Chad", "Chile", "China", "Chipre", "Ciudad del Vaticano", "Colombia", "Comoras", "Corea del Norte", "Corea del Sur", "Costa de Marfil", "Costa Rica", "Croacia", "Cuba", "Dinamarca", "Dominica", "Ecuador", "Egipto", "El Salvador", "Emiratos Árabes Unidos", "Eritrea", "Eslovaquia", "Eslovenia", "España", "Estados Unidos", "Estonia", "Etiopía", "Filipinas", "Finlandia", "Fiyi", "Francia", "Gabón", "Gambia", "Georgia", "Ghana", "Granada", "Grecia", "Guatemala", "Guyana", "Guinea", "Guinea ecuatorial", "Guinea-Bisáu", "Haití", "Honduras", "Hungría", "India", "Indonesia", "Irak", "Irán", "Irlanda", "Islandia", "Islas Marshall", "Islas Salomón", "Israel", "Italia", "Jamaica", "Japón", "Jordania", "Kazajistán", "Kenia", "Kirguistán", "Kiribati", "Kuwait", "Laos", "Lesoto", "Letonia", "Líbano", "Liberia", "Libia", "Liechtenstein", "Lituania", "Luxemburgo", "Madagascar", "Malasia", "Malaui", "Maldivas", "Malí", "Malta", "Marruecos", "Mauricio", "Mauritania", "México", "Micronesia", "Moldavia", "Mónaco", "Mongolia", "Montenegro", "Mozambique", "Namibia", "Nauru", "Nepal", "Nicaragua", "Níger", "Nigeria", "Noruega", "Nueva Zelanda", "Omán", "Países Bajos", "Pakistán", "Palaos", "Panamá", "Papúa Nueva Guinea", "Paraguay", "Perú", "Polonia", "Portugal", "Reino Unido", "República Centroafricana", "República Checa", "República de Macedonia", "República del Congo", "República Democrática del Congo", "República Dominicana", "República Sudafricana", "Ruanda", "Rumanía", "Rusia", "Samoa", "San Cristóbal y Nieves", "San Marino", "San Vicente y las Granadinas", "Santa Lucía", "Santo Tomé y Príncipe", "Senegal", "Serbia", "Seychelles", "Sierra Leona", "Singapur", "Siria", "Somalia", "Sri Lanka", "Suazilandia", "Sudán", "Sudán del Sur", "Suecia", "Suiza", "Surinam", "Tailandia", "Tanzania", "Tayikistán", "Timor Oriental", "Togo", "Tonga", "Trinidad y Tobago", "Túnez", "Turkmenistán", "Turquía", "Tuvalu", "Ucrania", "Uganda", "Uruguay", "Uzbekistán", "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Yibuti", "Zambia", "Zimbabue"
            ],
            provincias: ['Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila', 'Badajoz', 'Barcelona', 'Burgos', 'Cáceres',
                'Cádiz', 'Cantabria', 'Castellón', 'Ceuta', 'Ciudad Real', 'Córdoba', 'La Coruña', 'Cuenca', 'Gerona', 'Granada', 'Guadalajara',
                'Guipúzcoa', 'Huelva', 'Huesca', 'Islas Baleares', 'Jaén', 'León', 'Lérida', 'Lugo', 'Madrid', 'Málaga', 'Melilla', 'Murcia', 'Navarra',
                'Orense', 'Palencia', 'Las Palmas', 'Pontevedra', 'La Rioja', 'Salamanca', 'Segovia', 'Sevilla', 'Soria', 'Tarragona',
                'Santa Cruz de Tenerife', 'Teruel', 'Toledo', 'Valencia', 'Valladolid', 'Vizcaya', 'Zamora', 'Zaragoza'],
            nivelesidioma: {
                0: 'Principiante',
                1: 'Intermedio',
                2: 'Avanzado',
                3: 'Bilingüe',
                4: 'Nativo'
            },
            tipoparticipacion: {
                0: 'Entrevistador',
                1: 'Miembro de Tribunal'
            },
            tipoponente: {
                0: 'Elumni',
                1: 'Be'
            },
            tipobecas: {
                0: 'Caixa',
                1: 'Fullbrigth',
            },



        },
        currentNiveles: []
    },
    getters: {
        getDominios: state => state.dominios,
        getCurrentNiveles: state => state.currentNiveles,
        getNiveles: state => state.dominios.nivel
    },
    actions: {
        setNiveles: ({ commit, state }, ids) => {
            let niveles;
            if (ids && ids.length > 0) {
                // Filtrar por IDs específicos
                niveles = Object.entries(state.dominios.nivel)
                  .filter(([key]) =>  ids.includes(key))
                  .map(([key, value]) => ({ id: key, value: value }));
            } else {
                // Devolver todos los dominios de nivel
                niveles = Object.entries(state.dominios.nivel)
                  .map(([key, value]) => ({ id: key, value: value }));
            }
            commit('setCurrentNiveles', niveles);
        }
    },
    mutations: {
        setCurrentNiveles: (state, ids) => {
            state.currentNiveles = ids;
        }
    }
}

export default dominios;
